import React from "react";

interface IDropdownOptionProp {
	label: string;
	value: string;
}

interface IDropdownBoxProps {
	defaultText: string;
	options: IDropdownOptionProp[];
	onSelected: (selectedOption: IDropdownOptionProp) => void;
	disabled?: boolean;
	font?: string;
}

const DropdownDefaultBox: React.FC<IDropdownBoxProps> = ({
	defaultText,
	options,
	onSelected,
	disabled = false,
	font = "font-Poppins",
}) => {
	const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
		const selectedOption = options.find(
			(option) => option.value === event.target.value
		);
		if (selectedOption) {
			onSelected(selectedOption);
		}
	};

	return (
		<div className="relative w-full">
			<select
				className={`block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm bg-white appearance-none focus:ring-2 focus:ring-blue-400 focus:border-blue-500 ${font} font-medium text-md text-gray-700 cursor-pointer`}
				onChange={handleChange}
				disabled={disabled}
				defaultValue=""
			>
				<option value="" disabled hidden>
					{defaultText}
				</option>
				{options.map((option, index) => (
					<option
						key={index}
						value={option.value}
						className="text-gray-900 font-Poppins"
					>
						{option.label}
					</option>
				))}
			</select>

			{/* Custom arrow icon (SVG or FontAwesome) */}
			<div className="absolute inset-y-0 right-2 flex items-center pointer-events-none">
				<svg
					className="w-5 h-5 text-gray-500"
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 20 20"
					fill="currentColor"
				>
					<path
						fillRule="evenodd"
						d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 011.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
						clipRule="evenodd"
					/>
				</svg>
			</div>
		</div>
	);
};

export default DropdownDefaultBox;
